/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import { Box } from '@mui/material';
import { SPACE_VEHICLE_DETAILS_PANEL_WIDTH } from '../FullSpaceVehicleViewContainer';
import { FULL_SPACE_VEHICLE_VIEW_MAP_HEIGHT } from '../FullSpaceVehicleViewMapContainer';
import { TAIL_DETAILS_PANEL_WIDTH } from '../../../../fleet/TailDetailsPanel/TailDetailsPanel';

interface ChartContainerProps {
  children: JSX.Element[] | JSX.Element;
}

export const CHARTS_CONTAINER_WIDTH = `calc(100% - ${TAIL_DETAILS_PANEL_WIDTH}px)`;

const ChartsContainer = ({ children }: ChartContainerProps) => {
  return (
    <Box
      sx={{
        width: CHARTS_CONTAINER_WIDTH,
        height: 'auto',
        position: 'absolute',
        top: FULL_SPACE_VEHICLE_VIEW_MAP_HEIGHT,
        left: SPACE_VEHICLE_DETAILS_PANEL_WIDTH,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {children}
    </Box>
  );
};

export default ChartsContainer;
